import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAPI } from '../hooks/useAPI';
import { TemplateData } from '../types';
import { TemplateViewr } from './templates/TemplateViewr';
import { ErrorApp404 } from './errors/ErrorApp404';

export const Pages = () => {
  const { uuid } = useParams();
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(true);
  const { fetchData } = useAPI();
  const [template, setTemplate] = useState<TemplateData | null>(null);

  const refetchPage = async () => {
    if (uuid === '' || uuid === '/') return;
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData(`/pages/${uuid}?user_id=1`);
    if (!errors && data?.template) {
      setTemplate(data.template);
    }
    isLoading.current = false;
    setSIsLoading(false);
  }

  useEffect(() => {
    if (!isLoading.current) {
      refetchPage();
    }
  }, [uuid]);

  return (
    <>
    {
      template === null && !sIsLoading  ? (
        <ErrorApp404 />
      ) : (
        <TemplateViewr template_id={template?.id ?? ''} />
      )
    }
    </>
  );
};
